import { RefObject } from 'react';
import { useOrderTablePreference } from '@/pages/orders/_hooks/useOrderTablePreference';

import {
  adminPageUrl,
  marketColumn,
  orderDateColumn,
  orderNoColumn,
  orderStatus,
  productNameColumn,
  productNoColumn,
  productOptionColumn,
  quantityColumn,
  receiverColumn,
  recevierMemo,
  salesAmountColumn,
} from '../orderTableColumnBlocks';

import EmptyFaceIcon from '@/assets/icons/EmptyFaceIcon.svg?react';
import { TooltipProvider } from '@/components/atoms/PcTooltip';
import { LayoutOrderColumn } from '@/pages/orders/_layouts/LayoutOrderColumn';
import { OrderItem } from '@/types/order-list';
import { InfiniteScrollSentinel } from '../../../common/InfiniteScrollSentinel';
import MarketTable from '../../../common/MarketTable';

interface Props {
  orderList: OrderItem[];
  listEndSentinelRef: RefObject<HTMLDivElement>;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}

export function OrderTableColumn({
  orderList,
  listEndSentinelRef,
  hasNextPage,
  isFetchingNextPage,
}: Props) {
  const columns = [
    orderNoColumn,
    orderStatus,
    marketColumn,
    orderDateColumn,
    productNameColumn,
    productOptionColumn,
    salesAmountColumn,
    quantityColumn,
    productNoColumn({ showSellerPageButton: true }),
    adminPageUrl,
    receiverColumn,
    recevierMemo,
  ];

  const columnIds = columns.map((column) => column.id as string);
  const { columnOrder, setColumnOrder, columnSizing, setColumnSizing } = useOrderTablePreference({
    storageKey: 'delivered',
    columnIds,
  });

  return (
    <TooltipProvider>
      <LayoutOrderColumn className="relative">
        <MarketTable
          orderList={orderList}
          columns={columns}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
          columnSizing={columnSizing}
          onColumnSizingChange={setColumnSizing}
          enableColumnResize
          bodyFooter={
            <InfiniteScrollSentinel
              listEndSentinelRef={listEndSentinelRef}
              hasNextPage={hasNextPage}
              isFetchingNextPage={isFetchingNextPage}
            />
          }
        />
        {orderList.length === 0 && (
          <div className="absolute inset-0 top-[40px] z-[20] flex flex-col items-center justify-center gap-[20px] rounded-[20px] bg-white">
            <EmptyFaceIcon />
            <p className="text-gr-500">검색결과가 없어요.</p>
          </div>
        )}
      </LayoutOrderColumn>
    </TooltipProvider>
  );
}

export default OrderTableColumn;
